export default __webpack_public_path__ + "b25ac9d29806209a5d3a471623257a1a.svg";